import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { navigate } from 'gatsby';
import { connect } from 'react-redux';
import { Grid, makeStyles, Button } from '@material-ui/core';

import Tab from 'src/components/tab';
import InfoCard from 'src/components/infoCard';

import { setTabExpend } from './slice';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    paddingBottom: theme.spacing(2),
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
}));

const ActiveCalls = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title10 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <>
      <Tab title={prismicData.title10.text} drag onClick={handelExpand} expanded={isTabExpended}>
        <Grid container spacing={2}>
          {[...Array(6).keys()].map(ele => (
            <Grid key={ele} item xs={12} md={4}>
              <InfoCard
                source="Organic"
                lead={{ name: 'Jane Doe', phone: '+16096664476' }}
                rep={{ name: 'Jane Doe', phone: '+16096664476' }}
                time="8:20 AM"
              />
            </Grid>
          ))}
        </Grid>
      </Tab>
      <div className={classes.buttonWrapper}>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          disableElevation
          onClick={() => {
            navigate('/me/active-calls/');
          }}
        >
          View all Active calls
        </Button>
      </div>
    </>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { activeCalls } = overview;
  return { ...activeCalls };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ActiveCalls));
